export const KEYS_TO_INVALIDATE_WHEN_CONFIRMING = [
  'upcoming-consultation-list',
  'reservation-consultation-list',
  'consultation-list',
  'scheduled',
  'realtiment-appointment',
] as const
